import React from 'react'

const HomeScreen = () => {
  return (

    <div>Bem vindo ao Issue Tracker!</div>
  )
}

export default HomeScreen
